var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgChatCenteredText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.9999H20",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.9999H20",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7087 24.4854L16.8575 27.5708C16.7686 27.7189 16.643 27.8414 16.4927 27.9265C16.3424 28.0116 16.1727 28.0563 16 28.0563C15.8273 28.0563 15.6576 28.0116 15.5073 27.9265C15.357 27.8414 15.2314 27.7189 15.1425 27.5708L13.2913 24.4854C13.2025 24.3374 13.0768 24.2148 12.9265 24.1297C12.7762 24.0447 12.6065 23.9999 12.4338 23.9999H5C4.73478 23.9999 4.48043 23.8946 4.29289 23.7071C4.10536 23.5195 4 23.2652 4 22.9999V7C4 6.73478 4.10536 6.48043 4.29289 6.29289C4.48043 6.10536 4.73478 6 5 6H27C27.2652 6 27.5196 6.10536 27.7071 6.29289C27.8946 6.48043 28 6.73478 28 7V23C28 23.2652 27.8946 23.5196 27.7071 23.7071C27.5196 23.8946 27.2652 24 27 24L19.5662 23.9999C19.3935 23.9999 19.2238 24.0447 19.0735 24.1297C18.9232 24.2148 18.7975 24.3374 18.7087 24.4854V24.4854Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatCenteredText);
export default __webpack_public_path__ + "static/media/ChatCenteredText.904221cc0bafde441dd077f63c27900d.svg";
export { ForwardRef as ReactComponent };